/**
 * Contains language related methods.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
import GeneralUtility from './general-utility';

export default class LanguageUtility {
    /**
     * Current ISO 639-1 language code.
     */
    private static _language: string;

    /**
     * Current language ID.
     */
    private static _languageId: number;

    /**
     * Language labels.
     */
    private static _labels: { [key: string]: string };

    /**
     * Gets the ISO 639-1 language code.
     */
    static get language(): string {
        if (this._language === undefined) {
            this._language = GeneralUtility.getGlobalProperty('language');
        }
        return this._language;
    }

    /**
     * Gets the language ID.
     */
    static get languageId(): number {
        if (this._languageId === undefined) {
            this._languageId = parseInt(GeneralUtility.getGlobalProperty('languageId'));
        }
        return this._languageId;
    }

    /**
     * Gets the language labels.
     */
    static get labels(): { [key: string]: string } {
        if (this._labels === undefined) {
            this._labels = GeneralUtility.getGlobalProperty('labels');
        }
        return this._labels;
    }

    /**
     * Gets a language label.
     *
     * @param {string} key Key of the label to get
     */
    static getLabel(key: string): string {
        if (this.labels.hasOwnProperty(key)) {
            return this.labels[key];
        }
        return '';
    }
}
